import { toQueryList } from '@/common/app/modules/media/shareOfVoice'
import { ShareOfVoiceInsights } from '@/common/model/media/shareOfVoice'

import GeoInsightsPanel, {
  InsightBlock
} from '@/components/container/modules/mediaGeo/common/GeoInsightsPanel'

interface Props {
  insights: ShareOfVoiceInsights
}

// インサイト（強い/弱いクエリ・改善案）
const ShareOfVoiceInsightsPanel = ({ insights }: Props) => {
  const dominant = toQueryList(insights.dominant_queries)
  const weak = toQueryList(insights.weak_queries)

  const blocks: InsightBlock[] = [
    ...(dominant.length > 0
      ? [{ title: '強いクエリ', tone: 'positive' as const, texts: dominant }]
      : []),
    ...(weak.length > 0 ? [{ title: '弱いクエリ', tone: 'negative' as const, texts: weak }] : [])
  ]

  return <GeoInsightsPanel blocks={blocks} recommendation={insights.recommendation} />
}

export default ShareOfVoiceInsightsPanel
